import {Link} from "react-router-dom"

const LoginPrompt = () => {
    return (
      <div className="shadow-md rounded-md p-4 sm:p-8">
        <h1 className="sm:text-lg font-bold">Account</h1>
        <h6 className="text-sm sm:text-base text-slate-400">
          To place your order now, log in to your existing account or sign up.
        </h6>
        <div className="flex flex-col text-center my-4">
          <h6 className="text-sm font-semibold text-slate-400">Have an account?</h6>
          <Link to="/login">
            <button className="text-xs border-2 p-2 border-cyan-500 rounded text-cyan-500">
              LOGIN
            </button>
          </Link>
        </div>
        <div className="flex flex-col text-center my-4">
          <h6 className="text-sm font-semibold text-slate-400">
            New to Kitchen to door?
          </h6>
          <Link to="/signUp">
            <button className="text-xs border-2 p-2 border-cyan-500 rounded bg-cyan-500 text-white">
              SIGN UP
            </button>
          </Link>
        </div>
      </div>
    );
};

export default LoginPrompt;